module.exports = __webpack_public_path__ + "static/img/jianjiePic.f0c79b0a.png";